export default "__VITE_ASSET__d1786275__"